var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@chakra-ui/react";
import { getPageHref } from "@/components/Pagination/PageButtonHelper";
import { getCurrentPageNumber } from "@/components/utils";
export var PrevPageButton = function (_a) {
    var pageCursors = _a.pageCursors, searchParams = _a.searchParams, pageClickHandler = _a.pageClickHandler, countryParam = _a.countryParam;
    var currentPageNumber = getCurrentPageNumber(pageCursors);
    var pageCursor = pageCursors.get(currentPageNumber - 1);
    if (pageCursor == null || pageCursor == "")
        return _jsx(_Fragment, {});
    return (_jsx(Button, __assign({ asChild: true, "aria-label": "Previous page", onClick: function (event) { return pageClickHandler(event, pageCursor); }, variant: "pagination" }, { children: _jsx("a", __assign({ href: getPageHref(searchParams, pageCursor, countryParam) }, { children: "\u27E8" })) })));
};
